import React from "react";
import SubTitle from "../../../components/SubTitle";
import {useGetQuery, useRemoveMutation} from "../../../hooks/useQueryHooks";
import {ResponseList, ResponseRemove} from "../../../models/clientModels/interfaces/Response";
import {
  EDCategory,
  initialEDCategoryListParams,
} from "../../../models/serverModels/education/EDCategory";

import {
  Breadcrumbs,
  Button,
  Link as Linked,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import * as categoryListApi from "../../../api/educationApi/educationCategoryApi";
import {SubMenuGroup} from "../../../styledComponents/StyledListContainer";

import HomeIcon from "@mui/icons-material/Home";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {alertStateAtom} from "../../../Recoil/Atom/AlertAtom";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import * as categoryApi from "../../../api/educationApi/educationCategoryApi";
import MWSkeleton from "../../../components/MWSkeleton";
import * as Params from "../../../models/clientModels/interfaces/apiParams";
import DataSaverOnIcon from "@mui/icons-material/DataSaverOn";
import {StyledNoneScrollTable, StyledNoneStickyTable} from "../../../styledComponents/StyledTable";

const CategoryList = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const categoryId = {
    depth: 0,
    parentUID: 0,
  };

  const tokenState = useRecoilValue(tokenSelector);

  const setAlertState = useSetRecoilState(alertStateAtom);

  // region: Query (교육과정 카테고리 리스트)
  const {
    data: category,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EDCategory>>({
    key: ["EducationCategoryList", {...initialEDCategoryListParams, token: tokenState}],
    api: () => categoryListApi.getList({...initialEDCategoryListParams, token: tokenState}),
  });

  const {mutate: removeMutate} = useRemoveMutation<ResponseRemove, Params.Remove>({
    api: categoryApi.remove,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries("EducationCategoryList");
      },
    },
  });

  return (
    <React.Fragment>
      <SubTitle subTitle="대 분류목록" />
      <SubMenuGroup>
        <div role="presentation">
          <Breadcrumbs aria-label="breadcrumb" sx={{paddingLeft: "8px"}}>
            <Linked sx={{display: "flex", alignItems: "center"}} color="inherit" href="">
              <HomeIcon sx={{mr: 0.5}} fontSize="inherit" />
              대분류
            </Linked>
          </Breadcrumbs>
        </div>
        <Button
          color="primary"
          variant="outlined"
          size="small"
          startIcon={<DataSaverOnIcon />}
          onClick={() => {
            navigate(`/Education/Create/${categoryId.depth}/${categoryId.parentUID}`);
          }}
        >
          추가
        </Button>
      </SubMenuGroup>
      <StyledNoneScrollTable>
        <Table>
          <StyledNoneStickyTable>
            <TableRow>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">이름</TableCell>
              <TableCell align="center">분류</TableCell>
              <TableCell align="center">편집</TableCell>
            </TableRow>
          </StyledNoneStickyTable>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={4} />
            ) : (
              category?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{item.name}</TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        navigate(`/Education/MiddleCategoryList/${item.uid}`, {
                          state: item.uid,
                        });
                      }}
                    >
                      하위분류
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      sx={{marginRight: "16px"}}
                      onClick={() => {
                        navigate(`/Education/Update/${categoryId.depth}/${categoryId.parentUID}`, {
                          state: item.uid,
                        });
                      }}
                    >
                      편집
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => {
                        setAlertState({
                          toggle: true,
                          message: "대분류를 삭제하시겠습니까?",
                          execution: () => removeMutate({token: tokenState, id: item.uid}),
                        });
                      }}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledNoneScrollTable>
    </React.Fragment>
  );
};

export default CategoryList;
